<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="sourceUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/merchandiser/util/url'
import UPDATE from '@/components/page/update'

export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  mounted() {

  },
  created() {

  },
  methods: {

    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('新增' == clickName) {
        this.$refs.sourceUpdate.open()
      }
    },
    bthClick(clickName, row) {
      if (clickName == 'mappingEdit') {
        this.$refs.sourceUpdate.open(row)
      } else if (clickName == 'mappingDel') {
        this.mappingDel(row)
      }
    },
    mappingDel(row) {
      this.dataChange(Url.company.mappingDel, row, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submit(model) {
      this.dataChange(Url.company.mappingEdit, model, res => {
        if (res.code == 0) {
          this.$refs.sourceUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }

  },
  data() {
    return {
      queryData: {},
      updateData: {
        cols: [
          { title: '產品主鍵', field: 'baseSymbol' },
          { title: '產品_8', field: 'symbol8' },
          { title: '產品_16', field: 'symbol16' },
          { title: '產品_151', field: 'symbol151' }
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { click: window.$t('common.search') },
          { click: '新增', auth: 'symbol:mapping:add' }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.company.mappingList,
        selection: false,
        sequence: true,
        size: 10,
        method: 'get',
        cols: [
          { title: '產品主鍵', field: 'baseSymbol' },
          { title: '產品_8', field: 'symbol8' },
          { title: '產品_16', field: 'symbol16' },
          { title: '產品_151', field: 'symbol151' },
          {
            title: '創建時間', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '操作',
            btnClick: [
              {
                name: '移除',
                click: 'mappingDel',
                type: 'primary',
                icon: 'el-icon-add',
                auth: 'symbol:mapping:del'
              },
              {
                name: '編輯',
                click: 'mappingEdit',
                type: 'primary',
                icon: 'el-icon-add',
                auth: 'symbol:mapping:edit'
              }
            ]
          }
        ]
      }
    }
  }
}
</script>
